import React from 'react';
import { useTranslation } from 'react-i18next';
import { Edit, Trash2 } from 'lucide-react';

function PostList({ posts, onEdit, onDelete }) {
  const { t } = useTranslation();

  return (
    <div className="bg-white rounded-3xl p-8 md:p-12 shadow-[0_8px_32px_rgba(59,48,45,0.04)] border border-accent/30">
      <h2 className="font-playfair text-3xl font-medium text-charcoal mb-8">
        {t('admin.posts')}
      </h2>
      <div className="space-y-4">
        {posts.map((post) => (
          <div
            key={post.id}
            className="flex items-center justify-between p-6 rounded-2xl border border-accent/30 hover:border-primary/30 transition-colors"
            data-testid={`post-item-${post.id}`}
          >
            <div className="flex-1">
              <h3 className="font-medium text-charcoal mb-1">{post.title}</h3>
              <p className="text-sm text-muted-text">{new Date(post.created_at).toLocaleDateString()}</p>
            </div>
            <div className="flex space-x-2">
              <button
                onClick={() => onEdit(post)}
                className="p-2 rounded-full hover:bg-accent/30 transition-colors"
                data-testid={`edit-post-${post.id}`}
              >
                <Edit className="w-5 h-5 text-primary" />
              </button>
              <button
                onClick={() => onDelete(post.id)}
                className="p-2 rounded-full hover:bg-red-100 transition-colors"
                data-testid={`delete-post-${post.id}`}
              >
                <Trash2 className="w-5 h-5 text-red-600" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PostList;
